import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import React, { Component } from 'react';
import { LinkedProduct, Popup } from '../../components/';
import { HtmlEntitiesDecode } from '../../../../shared/services/';

export default class LinkedProductContainer extends Component {
  constructor(props) {
    super(props);
    const rsWebProductModel = window.rs.web.product.model;
    Object.keys(rsWebProductModel.labels.linkedProducts).forEach(
      key => { rsWebProductModel.labels.linkedProducts[key] = HtmlEntitiesDecode(rsWebProductModel.labels.linkedProducts[key]); },
    );
    this.state = {
      masterProductStockNumber: rsWebProductModel.stockNumber,
      linkedProducts: rsWebProductModel.linkedProducts,
      labels: rsWebProductModel.labels.linkedProducts,
      contextPath: rsWebProductModel.contextPath,
      name: HtmlEntitiesDecode(rsWebProductModel.name),
      showPopup: true,
      productNumber: rsWebProductModel.productNumber,
      compareScreenUrl: rsWebProductModel.isDiscontinued ? '/web/cpd/' : '/web/cpo/',
    };
  }

  handleClick = () => {
    window.location.assign(`${this.state.compareScreenUrl}${this.state.productNumber}/`);
  }

  productNameFormatted() {
    return this.state.labels.productNamePlaceholder.replace(/###/g, this.state.name);
  }

  closePopup = () => {
    this.setState({
      showPopup: false,
    });
  }

  render() {
    return (
      this.state.linkedProducts && this.state.linkedProducts.length > 0 &&
      <div className="linked-products">
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionAppear
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {this.state.showPopup &&
          <div className="linked-product-popup">
            <Popup open={this.state.showPopup} onClose={this.closePopup}>
              <p className="linked-product-heading">{this.productNameFormatted()}</p>
              <p>{this.state.labels.hereIsOur}</p>
            </Popup>
          </div>}
        </ReactCSSTransitionGroup>
        <div className="linked-products-header-container">
          <div className="linked-products-header">{this.state.labels.alternativeProducts}</div>
          <div className="linked-product-compare">
            <a
              role="button"
              className="btn btn-secondary-blue"
              tabIndex="-1"
              onClick={this.handleClick}
            >{this.state.labels.compare}
            </a>
          </div>
        </div>
        {this.state.linkedProducts.map(item => (
          <LinkedProduct
            key={item.id}
            {...item}
            labels={this.state.labels}
            contextPath={this.state.contextPath}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/LinkedProduct/LinkedProduct.js